// src/data/faqsData.js
import { 
  ShieldCheck, 
  CreditCard, 
  User, 
  Rocket,
  Truck,
  Medal,
  Headphones,
  MessageCircle,
  Zap,          // برای ارسال سریع
  Shield,       // برای پرداخت ایمن
  Award,        // برای ضمانت کیفیت
  Headset,      // برای پشتیبانی
  HelpCircle
} from 'lucide-react';

export const faqsData = [
  // Security - حریم خصوصی و امنیت
  { 
    id: 1, 
    category: "security",
    question: "چگونه می‌توانم سفارش خود را پیگیری کنم؟",
    answer: "برای پیگیری سفارش خود، وارد حساب کاربری شوید و از بخش 'سفارشات' وضعیت سفارش خود را مشاهده کنید. همچنین کد رهگیری پس از ارسال برای شما پیامک خواهد شد."
  },
  { 
    id: 2, 
    category: "security",
    question: "آیا اطلاعات من در اریس‌وود محفوظ است؟",
    answer: "بله، تمامی اطلاعات کاربران با بالاترین استانداردهای امنیتی محافظت می‌شود و هیچ اطلاعاتی با اشخاص ثالث به اشتراک گذاشته نمی‌شود."
  },
  { 
    id: 3, 
    category: "security",
    question: "چگونه می‌توانم رمز عبور خود را بازیابی کنم؟",
    answer: "برای بازیابی رمز عبور، روی گزینه 'فراموشی رمز عبور' در صفحه ورود کلیک کنید و ایمیل خود را وارد کنید. لینک بازیابی برای شما ارسال خواهد شد."
  },

  // Payment - پرداخت و فاکتور
  { 
    id: 4, 
    category: "payment",
    question: "روش‌های پرداخت در اریس‌وود چیست؟",
    answer: "پرداخت از طریق درگاه‌های بانکی معتبر، کارت به کارت، و پرداخت در محل برای برخی شهرها امکان‌پذیر است."
  },
  { 
    id: 5, 
    category: "payment",
    question: "هزینه ارسال چقدر است و چقدر طول می‌کشد؟",
    answer: "هزینه ارسال بر اساس وزن و مقصد محاسبه می‌شود. زمان تحویل معمولاً بین ۳ تا ۵ روز کاری است و برای شهرهای بزرگ ۱ تا ۲ روز کاری."
  },
  { 
    id: 6, 
    category: "payment",
    question: "آیا امکان پرداخت اقساطی وجود دارد؟",
    answer: "بله، امکان پرداخت اقساطی از طریق برخی بانک‌های عامل و موسسات اعتباری فراهم شده است. برای اطلاعات بیشتر با پشتیبانی تماس بگیرید."
  },
  { 
    id: 7, 
    category: "payment",
    question: "چگونه فاکتور خرید خود را دریافت کنم؟",
    answer: "پس از تکمیل خرید، فاکتور به ایمیل شما ارسال می‌شود. همچنین می‌توانید در بخش 'سفارشات' حساب کاربری خود، فاکتور را دانلود کنید."
  },

  // Main - سوالات اصلی
  { 
    id: 8, 
    category: "main",
    question: "آیا امکان بازگشت کالا وجود دارد؟",
    answer: "بله، در صورت عدم رضایت از کیفیت محصول، تا ۷ روز پس از تحویل امکان مرجوعی وجود دارد. محصول باید در بسته‌بندی اصلی و بدون استفاده باشد."
  },
  { 
    id: 9, 
    category: "main",
    question: "آیا محصولات چوبی اریس‌وود گارانتی دارند؟",
    answer: "بله، تمامی محصولات چوبی دارای گارانتی اصالت و کیفیت به همراه ضمانت ۱۲ ماهه در برابر ایرادات ساخت هستند."
  },
  { 
    id: 10, 
    category: "main",
    question: "چگونه از اصالت محصولات اطمینان حاصل کنم؟",
    answer: "همه محصولات اریس‌وود دارای کد رهگیری و هولوگرام اصالت هستند. با اسکن کد QR روی محصول، می‌توانید از اصالت آن اطمینان حاصل کنید."
  },
  { 
    id: 11, 
    category: "main",
    question: "آیا امکان سفارش محصولات به صورت عمده وجود دارد؟",
    answer: "بله، برای سفارش‌های عمده با تخفیف ویژه، با تیم فروش اریس‌وود تماس بگیرید تا مشاوره لازم را دریافت کنید."
  },

  // Account - حساب کاربری
  { 
    id: 12, 
    category: "account",
    question: "چگونه می‌توانم حساب کاربری خود را ویرایش کنم؟",
    answer: "برای ویرایش حساب کاربری، وارد پروفایل خود شوید و از بخش 'ویرایش اطلاعات' می‌توانید اطلاعات خود را به‌روزرسانی کنید."
  },
  { 
    id: 13, 
    category: "account",
    question: "چگونه رمز عبور خود را تغییر دهم؟",
    answer: "برای تغییر رمز عبور، وارد حساب کاربری شوید و از بخش 'امنیت' گزینه تغییر رمز عبور را انتخاب کنید."
  },
  { 
    id: 14, 
    category: "account",
    question: "چگونه حساب کاربری خود را حذف کنم؟",
    answer: "برای حذف حساب کاربری، با پشتیبانی تماس بگیرید. توجه داشته باشید که پس از حذف، تمام اطلاعات شما از سیستم پاک خواهد شد."
  },
  { 
    id: 15, 
    category: "account",
    question: "چگونه آدرس خود را در حساب کاربری تغییر دهم؟",
    answer: "وارد حساب کاربری شوید، به بخش 'آدرس‌ها' بروید و آدرس جدید را اضافه یا آدرس قبلی را ویرایش کنید."
  },
];

export const categoriesData = [
  { id: "security", title: "حریم خصوصی", icon: "ShieldCheck", color: "from-emerald-500 to-teal-600", bg: "bg-emerald-50" },
  { id: "payment", title: "پرداخت و فاکتور", icon: "CreditCard", color: "from-blue-500 to-indigo-600", bg: "bg-blue-50" },
  { id: "main", title: "سوالات اصلی", icon: "User", color: "from-purple-500 to-pink-600", bg: "bg-purple-50" },
  { id: "account", title: "حساب کاربری", icon: "Rocket", color: "from-amber-500 to-orange-600", bg: "bg-amber-50" },
];

// ============================================================
// ✅ بخش ویژگی‌ها با آیکون‌های مناسب
// ============================================================
export const featuresData = [
  { 
    title: "ارسال سریع", 
    desc: "توسط پیک و باربری", 
    icon: Zap,  // ✅ آیکون مناسب برای ارسال سریع
    gradient: "from-emerald-400 to-teal-500" 
  },
  { 
    title: "پرداخت ایمن", 
    desc: "درگاه‌های معتبر", 
    icon: Shield,  // ✅ آیکون مناسب برای پرداخت ایمن
    gradient: "from-blue-400 to-indigo-500" 
  },
  { 
    title: "ضمانت کیفیت", 
    desc: "مرغوب‌ترین چوب", 
    icon: Award,  // ✅ آیکون مناسب برای ضمانت کیفیت
    gradient: "from-amber-400 to-orange-500" 
  },
  { 
    title: "پشتیبانی", 
    desc: "۲۴ ساعته، ۷ روز هفته", 
    icon: Headset,  // ✅ آیکون مناسب برای پشتیبانی
    gradient: "from-purple-400 to-pink-500" 
  },
];